(ns pfo.routes
  (:require #_:clj-kondo/ignore [taoensso.timbre :as timbre
                                 :refer [log trace debug info warn error fatal report logf
                                         tracef debugf infof warnf errorf fatalf reportf spy]]
            [pfo.task.core :as task-core]
            [pfo.document.core :as document-core]
            [pfo.admin.core :as admin-core]
            [pfo.mcp.core :as mcp-core]
            [pfo.dashboard.core :as dashboard-core]
            [pfo.category.core :as category-core]
            [pfo.collection.core :as collection-core]
            [pfo.signature.core :as signature-core]
            [pfo.auth.core :as auth-core]
            [pfo.chat.core :as chat-core]
            [pfo.im.core :as im-core]
            [pfo.state :as state]
            [pfo.flag :refer [document-queue-enabled?]]
            [pfo.util :as util]
            [cemerick.url :as url]
            [pfo.revroutes]
            [bidi.bidi :as bidi :refer [tag]]))

(defn route [tag-name view-fn & options]
  (let [{:keys [scroll-top? waypoint?]} (first options)]
    (tag (fn [route-params]
           (when waypoint?
             (let [sub-tag-name (:task_type (:query-params route-params))]
               (debugf "Waypoint, setting tag-name %s, sub-tag-name %s" tag-name sub-tag-name)
               (swap! state/nav-state state/add-nav-state {:tag-name tag-name :sub-tag-name sub-tag-name :route-params route-params})))
           (view-fn route-params)
           (when scroll-top? (.scrollTo js/window 0 0)))
      tag-name)))

;TODO fill the rest of routes
;; The review queue switch (#3008) strips the Unfiled review workspace route
;; whose entrypoints it hides, so the page cannot be reached by typing its URL.
(defonce routes ["/" (cond-> {"" (route :dashboard #'dashboard-core/dashboard {:waypoint? true})
                      "error" (route :error-page #'auth-core/error-page {})
                      "connected-apps" (route :connected-apps #'mcp-core/connected-apps-page {:waypoint? true})
                      "auth/" {["saml-login"] (route :saml-login #'auth-core/saml-login {})}
                      "collection/" {["details/" :id] (route :collection-details #'collection-core/collection-details {:waypoint? true})
                                     ["boir/" :id] (route :collection-boir-preview collection-core/collection-boir-pdf-preview {:waypoint? false})
                                     ["boir/efile/" :id] (route :collection-boir-efile-preview #'collection-core/collection-boir-efile-preview
                                                                {:waypoint? false
                                                                 :scroll-top? true})
                                     ["charts/" :id] (route :collection-charts #'collection-core/collection-charts {:waypoint? false})}

                      "signature/" {["sign/" :token] (route :sign #'signature-core/sign {:waypoint? false})
                                    ["view/" :token] (route :sign #'signature-core/view {:waypoint? false})
                                    ["link/" :task-id "/" :date] (route :sign-link #'signature-core/link {:waypoint? true})}

                      "task/" {["details/" :id "/" :complete_by] (route :task-details #'task-core/task-details {:waypoint? true})

                               ["details/" :id] (route :task-details-without-date #'task-core/task-details-without-date {:waypoint? true})

                               ["group/" :id "/details"] (route :task-group-details #'task-core/task-group-details {:waypoint? true})

                               "list" (route :task-list #'task-core/task-list {:waypoint? true})

                               "add" {"" (route :task-add #'task-core/task-add {:scroll-top? true})
                                      "/bulk" (route :task-add-bulk #'task-core/task-add-bulk {:scroll-top? true})}

                               ["add-or-choose"] (route :task-add-or-choose #'task-core/task-add-or-choose {:scroll-top? true})

                               "templategroup/list" (route :settings-templategroup-list #'admin-core/templategroup-list {:scroll-top? true})

                               ["edit/" :id "/" :complete_by] (route :task-edit #'task-core/task-edit {:scroll-top? true})
                               
                               "label/" {"list" (route :settings-template-label-list #'admin-core/template-label-list {:waypoint? true})}}

                      "document/" {["details/" :id] (route :document-details #'document-core/document-details {:waypoint? true })
                                   "list" (route :document-list #'document-core/document-list {:waypoint? true})

                                   ["list"] (route :document-list #'document-core/document-list {:waypoint? true})

                                   "unfiled" (route :document-unfiled #'document-core/unfiled-list {:waypoint? true})

                                   ["add-or-choose"] (route :document-add-or-choose #'document-core/add-or-choose {:scroll-top? true})

                                   "add" (route :document-add #'document-core/document-add {:scroll-top? true})

                                   ["edit/" :id] (route :document-edit #'document-core/document-edit {:scroll-top? true})

                                   "sign" (route :document-add #'document-core/signature-wait {:scroll-top? true})}

                      "category/" {["list"] (route :category-list #'category-core/category-list {:waypoint? true})}

                      "demo/" {"admin" (route :settings-demo-list #'admin-core/demo-list)}

                      "admin/" {"user/" {["edit/" :id] (route :settings-user-edit #'admin-core/user-edit)
                                         "add" (route :settings-user-add #'admin-core/user-add)
                                         "list" (route :settings-user-list #'admin-core/user-list {:waypoint? true})}
                                "applicenses" (route :settings-applicenses #'admin-core/application-licenses)
                                "category/list" (route :settings-categories #'admin-core/category-list)
                                "mcp/connections" (route :settings-mcp-connections #'mcp-core/connections-page {:waypoint? true})
                                "nomination/list" (route :settings-nominations #'admin-core/nomination-list)
                                "subscribers/" { "list" (route :settings-subscribers-list #'admin-core/subscribers-list)
                                                "add" (route :settings-subscriber-add #'admin-core/subscriber-add)
                                                [ "details/" :id ] (route :settings-subscriber-details #'admin-core/subscriber-edit)}
                                "family/" {[:id "/edit"] (route :settings-family-edit #'admin-core/family-edit)}
                                "templategroup/" {"add" (route :settings-templategroup-add #'admin-core/templategroup-add)
                                                  [:id] (route :settings-templategroup-preview #'admin-core/templategroup-preview)
                                                  [:id "/edit"] (route :settings-templategroup-edit #'admin-core/templategroup-edit)}
                                "contact/" {[:id "/edit"] (route :settings-contact-edit #'admin-core/contact-edit {:waypoint? true})}
                                "report/" {"dropboxsign" (route :settings-dropbox-sign-report #'admin-core/dropbox-sign-report)}
                                "metrics" (route :settings-metrics #'admin-core/metrics)}

                      "event/"  {"add" (route :event-add #'task-core/event-add {:scroll-top? true})

                                 "list" (route :event-list #'task-core/event-list {:waypoint? true})

                                 "details/" {[[#"[^/]+" :key] ""] (route :event-details #'task-core/event-details {:waypoint? true})
                                             ["id/" :id] (route :event-details-by-id #'task-core/event-details-by-id {:waypoint? true})}

                                 ["edit/" [#".+" :key]] (route :event-edit #'task-core/event-edit {:scroll-top? true})}
                      "support" {"" (route :support #'auth-core/support)}
                      "automation/" {"disposition/list" {"" (route :settings-disposition-list #'admin-core/disposition-list {:waypoint? true})
                                                         ["/family/" :id "/import"] (route :settings-disposition-import #'admin-core/disposition-import)}
                                     "label/" {"list" (route :settings-label-list #'admin-core/label-list {:waypoint? true})}
                                     "transaction/" {"list" (route :settings-transaction-list #'admin-core/transaction-list {:waypoint? true})
                                                     [:id "/documents"] (route :settings-transaction-document-list #'admin-core/transaction-document-list)}
                                     "collection/" {"list" (route :settings-automation-collection-list #'admin-core/automation-collection-list {:waypoint? true})}}
                      "ai/" {"settings" (route :settings-ai #'admin-core/ai {:waypoint? true})
                             "lmp" (route :settings-ai-lmp #'admin-core/ai-lmp {:waypoint? true})
                             "skill" (route :settings-ai-skill #'admin-core/ai-skill {:waypoint? true})
                             "usage" (route :settings-ai-usage #'admin-core/ai-usage {:waypoint? true})
                             "debug" (route :settings-ai-debug #'admin-core/ai-debug {:waypoint? true})
                             "feedback" (route :settings-ai-feedback #'admin-core/ai-feedback {:waypoint? true})
                             "billing" (route :settings-ai-billing #'admin-core/ai-billing {:waypoint? true})}

                      "bulkoperations/" {"list" (route :settings-bulkoperations-list #'admin-core/bulk-edit-list {:waypoint? true})
                                         ["apply/" :operation-id] (route :settings-bulkapply-details #'admin-core/bulk-apply-details {:waypoint? true})}
                      "chat" {"" (route :chat #'chat-core/chat  {:waypoint? true})}
                      ;; Where an AARK download link lands: the page saves the file and
                      ;; returns to the chat (#3004).
                      "artifact/" {[:id "/download"] (route :artifact-download #'chat-core/artifact-download {})}
                      "im" {"" (route :im #'im-core/im {:waypoint? true})}}

                     (not (document-queue-enabled?))
                     (update "document/" dissoc "unfiled"))])

(defn path-for
  "Given a  handler and an option map, return a
  path prepended with hash ('#') that would route to the handler.  The map must contain the values to any
  parameters required to create the path, and extra values are silently ignored."
  [handler & {:as params}]
  (when (nil? handler)
    (throw (ex-info "Cannot form URI from a nil handler" {})))

  (str "#" (bidi/unmatch-pair routes {:handler handler :params params}) 
       (when-let [query-params (:query-params params)] (str "?" query-params))))

(defn get-handler [location]
  (when-let [matched-route (bidi/match-route routes (:path (url/url location)))]
    [(:tag matched-route) (partial (:handler matched-route)
                                   (assoc (:route-params matched-route)
                                          :query-params
                                                               (clojure.walk/keywordize-keys (:query (url/url location)))
                                          :query-param-vectors (util/get-location-param-vectors location)))]))
(defn waypoint-path [nav-state & fallback-params]
  (if-let [waypoint-path (bidi/unmatch-pair routes {:handler (:tag-name nav-state) :params (:route-params nav-state)})]
    (let [query-params (get-in nav-state [:route-params :query-params])]
      (str "#" waypoint-path (when (seq query-params) (str "?" (util/make-params query-params)))))
    (apply path-for fallback-params)))

(defn last-waypoint-path [& fallback-params]
  (apply waypoint-path (last @state/nav-state) fallback-params))

; If the last used tag name is also the last in the nav-state buffer, it should be removed
; so that further consistent navigation back is possible
(defn- deletion-waypoint [& fallback-params]
  (if (= @state/last-nav-tag-name (:tag-name (last @state/nav-state)))
    [true (apply waypoint-path (last (butlast @state/nav-state)) fallback-params)]
    [false (apply waypoint-path (last @state/nav-state) fallback-params)]))

(defn go-to-last-waypoint [& fallback-params]
  (util/set-location (apply last-waypoint-path fallback-params)))

(defn go-to-deletion-waypoint [& fallback-params]
  (let [[remove-last-state path] (apply deletion-waypoint fallback-params)]
    (when remove-last-state (swap! state/nav-state state/remove-last-nav-state))
    (util/set-location path)))

(defn set-waypoint [tag-name & {:as route-params}]
  (swap! state/nav-state state/add-nav-state {:tag-name tag-name, :route-params route-params}))

(set! pfo.revroutes/path-for path-for)
(set! pfo.revroutes/go-to-deletion-waypoint go-to-deletion-waypoint)
(set! pfo.revroutes/go-to-last-waypoint go-to-last-waypoint)
(set! pfo.revroutes/set-waypoint set-waypoint)

